/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import { MessageService } from "primeng/api";
import { first } from "rxjs";
import { concatMap, tap } from "rxjs/operators";
import { AppActions } from "src/app/ngrx/app.actions.types";
import { AppState } from "src/app/ngrx/root.reducer";
import { LogService } from "../../shared/services/log.service";
import { RIPSIM_ICONS as ICONS } from "src/app/shared/models/icon-config.model";

@UntilDestroy()
@Component({
  selector: "rs-app-component",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store<AppState>,
    private logService: LogService,
    private messageService: MessageService
  ) {}
  isActiveSession = false;
  windowBlocked = false;
  spinnerVisible = false;
  spinnerType = "default";
  displayMessageDialog = false;
  displayMessageHeader = "";
  displayMessageContent = "";

  readonly ICONS = ICONS;

  /** Splits newline-delimited dialog content so multi-issue messages render as a list. */
  get displayMessageLines(): string[] {
    return this.displayMessageContent.split("\n");
  }

  ngOnInit() {
    this.logService.log("[AppComponent] ngOnInit() RiPSIM is loading...");
    this.store
      .select("auth")
      .pipe(
        first((authState) => authState.isAuthenticated === true),
        tap((authState) => {
          this.isActiveSession = authState.isAuthenticated;
        }),
        concatMap(() =>
          this.store.select("app").pipe(
            untilDestroyed(this),
            tap((appState) => {
              this.windowBlocked = appState.blockui;
              this.spinnerVisible = appState.spinner;
              this.spinnerType = appState.spinnerType;
            })
          )
        )
      )
      .subscribe((appState) => {
        if (appState.toastSeverity !== null && appState.toastDetail !== null) {
          this.messageService.add({ severity: appState.toastSeverity, detail: appState.toastDetail });
          this.store.dispatch(AppActions.ClearToastMessage());
        }
        if (appState.dialogContent && appState.dialogHeader && !this.displayMessageDialog) {
          this.displayMessageDialog = true;
          this.displayMessageHeader = appState.dialogHeader;
          this.displayMessageContent = appState.dialogContent;
        } else if (!appState.dialogContent && !appState.dialogHeader && this.displayMessageDialog) {
          this.displayMessageDialog = false;
          this.displayMessageHeader = "";
          this.displayMessageContent = "";
        }
      });

    // Fixes outlier condition preventing PNG appendTo="body" causing a body scroll under certain circumstances
    window.onscroll = () => {
      window.scrollTo(0, 0);
    };
  }

  ngOnDestroy() {
    this.logService.log("[AppComponent] ngOnDestroy() RiPSIM is unloading...");
  }

  closeMessageDialog() {
    this.store.dispatch(AppActions.ClearDialogMessage());
  }

  closeEsimLookupDialog() {
    this.store.dispatch(AppActions.HideEsimLookup());
  }
}
